import { render } from "./DatePicker.vue?vue&type=template&id=9f910904"
import script from "./DatePicker.vue?vue&type=script&lang=js"
export * from "./DatePicker.vue?vue&type=script&lang=js"
script.render = render

export default script